<a *ngFor="let mi of menuItems;let i = index">
    <span class="dropdown">
      <span class="dropdown-item">{{ mi.service?.code }} - {{ mi.service?.name }} <sw-dropdown-icon class="ml-auto"></sw-dropdown-icon></span>

    </span>
    <div class="submenu-container">
        <span *ngFor="let sub of mi.files;let j = index" class="submenu-item" (click)="onClick($event, i, j)"> {{ sub }}</span>
    </div>
</a>